import { Button, Dropdown, MenuProps } from "antd";
import { ReactComponent as AOIAddIcon } from "../../assets/svgs/icons/aoi-menu-icon.svg";
import { ReactComponent as SettingIcon } from "../../assets/svgs/icons/setting-processing-icon.svg";
import { emitCustomEvent } from "react-custom-events";
import * as THREE from "three";
import { useState } from "react";
import { ReactComponent as AOIsMenuIcon } from "../../assets/svgs/icons/aois-icon.svg";
import AoiSaveModal from "../modal/AoiSaveModal";
import { DownOutlined } from "@ant-design/icons";
import { AOIAddState } from "../../types/interfaces";

const aoisMenuItems: MenuProps['items'] = [
    {
        label: 'Processing Menu',
        key: '1',
        icon: <SettingIcon />,
    },
    {
        label: 'Add AOI',
        key: '2',
        icon: <AOIAddIcon />,
    },
];
interface AOIHeaderMenuProps {
    initAddingAOI: (isQuickDownload : boolean) => void;
}

const AOIHeaderMenu = ({ initAddingAOI } : AOIHeaderMenuProps) => {

    const handleAoisMenuClick = ({ key }: { key: string }) => {
        switch (key) {
            case '1':
                emitCustomEvent("openAOIProcessMenu", { data: null });
                break;
            case '2':
                initAddingAOI(false);
                break
            default:
        }
    };
    const aoisMenuProps = {
        items: aoisMenuItems,
        onClick: handleAoisMenuClick,
    };

    return (
        <>
            <Dropdown menu={aoisMenuProps} overlayClassName="menu_dropdown">
                <Button className='menu_button'>
                    <AOIsMenuIcon key="AoisMenuIcon" className='menu_icon' />
                    AOIs
                    <DownOutlined />
                </Button>
            </Dropdown>
        </>
    )
}
export default AOIHeaderMenu;